import { useCallback, useState } from 'react'

import useEventListener from './useEventListener'

interface KeyPressProps {
  element?: HTMLElement | Window
  targetKey: string,
  onKeyDown?: Function,
  onKeyUp?: Function
}

const useKeyPress = ({
  element = window,
  targetKey,
  onKeyDown = () => {},
  onKeyUp = () => {}
}: KeyPressProps) => {
  const [keyPressed, setKeyPressed] = useState(false)

  const downHandler = useCallback((event) => {

    if (event.key === targetKey) {
      setKeyPressed(true)
      onKeyDown(event)
    }
  }, [targetKey, onKeyDown])

  const upHandler = useCallback((event) => {
    if (event.key === targetKey) {
      setKeyPressed(false)
      onKeyUp(event)
    }
  }, [targetKey, onKeyUp])

  useEventListener('keydown', downHandler, element)
  useEventListener('keyup', upHandler, element)

  return keyPressed
}

export default useKeyPress
